import ModalsContext from "common/ModalsContext";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const MenuGroupContext = createContext({
  setActive: () => {},
});

export function MenuGroup({ label, children, icon, link, className, modal, clickHandler, iconJsx }) {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { openModal } = useContext(ModalsContext);
  const menuGroupContext = useContext(MenuGroupContext);

  useEffect(() => {
    if (active && !isOpen) {
      setIsOpen(true);
    }
  }, [active]);

  useEffect(() => {
    setActive(false);

    if (!link) {
      return;
    }

    setActive(location.pathname === link);
  }, [location]);

  function toggle() {
    setIsOpen(!isOpen);
  }

  return (
    <li
      onClick={(e) => {
        e.stopPropagation();

        if (link) {
          navigate(link);
        } else if (modal) {
          openModal({ type: modal });
        } else if (clickHandler) {
          clickHandler();
        } else {
          toggle();
        }
      }}
      className={className}
    >
      <a
        href="javascript:void(0);"
        className={`menu-toggle${isOpen ? " toggled" : ""}${
          active ? " active" : ""
        }${link ? " link" : ""}${modal ? " open-modal" : ""}${
          clickHandler ? " click-handler" : ""
        }`}
      >
        {iconJsx && iconJsx}
        {icon && <i className="material-icons">{icon}</i>}
        <span>{label}</span>
      </a>
      <ul className={`ml-menu${isOpen ? " open" : ""}`}>
        <MenuGroupContext.Provider
          value={{
            setActive: (value) => {
              setActive(value);
              menuGroupContext.setActive(value);
            },
          }}
        >
          {children}
        </MenuGroupContext.Provider>
      </ul>
    </li>
  );
}
